import { render, staticRenderFns } from "./k8s.cni.cncf.io.networkattachmentdefinition.vue?vue&type=template&id=44a1d633&"
import script from "./k8s.cni.cncf.io.networkattachmentdefinition.vue?vue&type=script&lang=js&"
export * from "./k8s.cni.cncf.io.networkattachmentdefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports